import React from 'react';
import { cn } from '../../../utils/classnames';

const SidebarItem = ({ icon: Icon, label, active = false, href }) => {
  return (
    <a
      href={href}
      className={cn(
        'flex items-center w-full px-4 py-5 transition-colors duration-200 relative truncate',
        active ? 'text-white bg-blueMedium font-semibold' : 'text-white hover:text-teal-200'
      )}
    >
      {active && <div className="absolute right-0 top-0 bottom-0 w-1 bg-tealLight" />}
      {Icon && <Icon strokeWidth={1.5} className={cn('w-5 h-5 mr-2 shrink-0', active && 'text-tealSoft')} />}
      {label}
    </a>
  );
};

export default SidebarItem;
